module.exports = {
    'welcome' : 'Добро <span class="blue--text text--darken-3">пожаловать!</span>',
    'sign_as_abiturient' : 'Вход в кабинет <span class="green--text text-darken-1">абитуриента</span>',
    'sign_as_college' : 'Вход в кабинет <span class="green--text text-darken-1">колледжа</span>',
    'sign_as_department' : 'Вход в кабинет <span class="green--text text-darken-1">ТиПО</span>',
    'abiturient_login_text' : '<p>Доступ в личный кабинет осуществляется через электронно-цифровую подпись (ЭЦП) граждан. При необходимости можете <a href="https://www.youtube.com/watch?v=Ilipo-v6zBo" target="_blank">посмотреть</a> или <a href="/portal/static/abiturient_instruction_ru.pdf" download>скачать</a> инструкцию по работе с системой.</p><p>ИС позволяет подавать документы для поступления в колледж на бесплатное обучение по государственному заказу и отслеживать их статус. Итоговые результаты отображаются в разделе ранжирование. Есть возможность задать интересующие вопросы в приемную комиссию.</p>',
    'college_login_text' : '<p>Доступ в личный кабинет осуществляется через электронно-цифровую подпись (ЭЦП) юридического учреждения. При необходимости можете <a href="#">посмотреть</a> или <a href="/portal/static/comission_instruction_ru.pdf">скачать</a> инструкцию по работе с системой.</p><p>Основной функционалом является рассмотрение и обработка поступивших заявок, назначение специальных экзаменов и консультации по приему.</p>',
    'department_login_text' : '<p>Доступ в личный кабинет осуществляется через электронно-цифровую подпись (ЭЦП) юридического учреждения. При необходимости можете <a href="#">посмотреть</a> или <a href="#">скачать</a> инструкцию по работе с системой.</p><p>В системе имеется мониторинг заявок, отображаются актуальные статистические данные, количество свободных мест по госзаказу подведомственных организаций (колледжей). Имеется виртуальный блог.</p>',
    'sign_for' : 'Вход для <span class="blue--text text--darken-3">организаций</span>',
    'Выберите способ подачи заявки': 'Выберите способ подачи заявки',
    'Как абитуриент': 'Как абитуриент',
    'Подать заявку на поступление от своего имени': 'Подать заявку на поступление от своего имени',
    'Через ГБДФЛ': 'Через ГБДФЛ',
    'Подать заявку на поступление за ребёнка через подтверждение по SMS': 'Подать заявку на поступление за ребёнка через подтверждение по SMS',
    'Назад к выбору способа': 'Назад к выбору способа',
    'Выберите детей': 'Выберите детей',
    'Выбор ребёнка': 'Выбор ребёнка',
    'Подтверждение по SMS': 'Подтверждение по SMS',
    'Мы отправили вам сообщение для подтверждения вашей личности. После подтверждения, нажмите на кнопку "Обновить".': 'Мы отправили вам сообщение для подтверждения вашей личности. После подтверждения, нажмите на кнопку "Обновить".',
    'Обновить': 'Обновить',
    'К сожалению, произошла ошибка при подтверждении вашей личности. Пожалуйста, попробуйте еще раз. Если проблема сохраняется, свяжитесь с поддержкой.': 'К сожалению, произошла ошибка при подтверждении вашей личности. Пожалуйста, попробуйте еще раз. Если проблема сохраняется, свяжитесь с поддержкой.',
    'Данные о детях, достигших выпускного возраста, отсутствуют в базе.': 'Данные о детях, достигших выпускного возраста, отсутствуют в базе.',
    'Выберите способ авторизации': 'Выберите способ авторизации',
    'Вход через ЭЦП': 'Вход через ЭЦП',
    'Авторизация с помощью электронно-цифровой подписи физического лица': 'Авторизация с помощью электронно-цифровой подписи физического лица',
    'Вход по паролю': 'Вход по паролю',
    'Авторизация с помощью логина и пароля личного кабинета': 'Авторизация с помощью логина и пароля личного кабинета',
    'Логин': 'Логин',
    'Ошибка авторизации': 'Ошибка авторизации',
    'Назад к выбору способа авторизации': 'Назад к выбору способа авторизации',
    'Пароль': 'Пароль',
    'ФИО': 'ФИО',
    'Форма оплаты': 'Форма оплаты',
    'Тип образования': 'Тип образования',
    'Квота приема': 'Квота приема',
    'Статус': 'Статус',
    'Подано через': 'Подано через',
    'Подано через ИС Абитуриент EDUS': 'Подано через ИС Абитуриент EDUS',
    'Источник': 'Источник',
    'Есть': 'Есть',
    'Нет': 'Нет',
    'Обязательное поле': 'Обязательное поле',
    'Неправильный формат ИИН': 'Неправильный формат ИИН',
    'Введите корректный E-mail': 'Введите корректный E-mail',
    'Неправильный формат телефона': 'Неправильный формат телефона',
    'Неправильный формат': 'Неправильный формат',
    'Год не может быть меньше 1901': 'Год не может быть меньше 1901',
    'Год не может быть больше текущего': 'Год не может быть больше текущего',
    'Дата не может быть позже текущей': 'Дата не может быть позже текущей',
    'Размер файла не должен превышать 4 Мб': 'Размер файла не должен превышать 4 Мб',
    'Размер файла не должен превышать 10 Мб': 'Размер файла не должен превышать 10 Мб',
    '(МАКСИМАЛЬНЫЙ ОБЪЕМ ФАЙЛА НЕ ДОЛЖЕН ПРЕВЫШАТЬ 10 МБ)': '(МАКСИМАЛЬНЫЙ ОБЪЕМ ФАЙЛА НЕ ДОЛЖЕН ПРЕВЫШАТЬ 10 МБ)',
    'Выберите ЭЦП': 'Выберите ЭЦП',
    'Введите пароль': 'Введите пароль',
    'Сменить пароль': 'Сменить пароль',
    'Смена пароля': 'Смена пароля',
    'Новый пароль': 'Новый пароль',
    'Пароль от ЭЦП': 'Пароль от ЭЦП',
    'Выберите ЭЦП физического лица': 'Выберите ЭЦП физического лица',
    'Пароль успешно изменен': 'Пароль успешно изменен',
    'Сохранить': 'Сохранить',
    'Закрыть': 'Закрыть',
    'Создание логина и пароля': 'Создание логина и пароля',
    'У вас пока нет логина и пароля. Создайте их для входа по паролю в личный кабинет.': 'У вас пока нет логина и пароля. Создайте их для входа по паролю в личный кабинет.',
    'Логин и пароль успешно созданы': 'Логин и пароль успешно созданы',
    'Неразвитые места': 'Неразвитые места',
    'Общее количество мест': 'Общее количество мест',
    'Оставшиеся места': 'Оставшиеся места',
    'Целевой грант': 'Целевой грант',
    'Код специальности': 'Код специальности',
    'Языковая группа': 'Языковая группа',
    'Остальные предметы': 'Остальные предметы',
    '+ Добавить предмет': '+ Добавить предмет',
    'Предмет': 'Предмет',
    'Учебное заведение': 'Учебное заведение',
    'Год окончания': 'Год окончания',
    'Документ об образовании': 'Документ об образовании',
    'Тип квоты': 'Тип квоты',
    'Медицинская справка 075/У (086)': 'Медицинская справка 075/У (086)',
    'Назначение экзаменов': 'Назначение экзаменов',
    'Дата проведения': 'Дата проведения',
    'Время (HH:mm)': 'Время (HH:mm)',
    'Место проведения': 'Место проведения',
    'Назначить': 'Назначить',
    'Оценка экзаменов': 'Оценка экзаменов',
    'Оценки аттестата': 'Оценки аттестата',
    'Выбрать': 'Выбрать',
    'Дата и время': 'Дата и время',
    'СБА': 'СБА',
    'СКБ': 'СКБ',
    'Общая статистика': 'Общая статистика',
    'Статистика по квотам': 'Статистика по квотам',
    'Выделенные места и Поступившие заявки': 'Выделенные места и Поступившие заявки',
    'Количество выделенных мест': 'Количество выделенных мест',
    'Выбери ребенка': 'Выбери ребенка',
    'Сегодня': 'Сегодня',
    'Неделя': 'Неделя',
    'Месяц': 'Месяц',
    'Все': 'Все',
    'Квалификация': 'Квалификация',
    'Тип оплаты': 'Тип оплаты',
    'Обучение по государственному заказу': 'Обучение по государственному заказу',
    'Государственный заказ': 'Государственный заказ',
    'Категория заявителя': 'Категория заявителя',
    'Номер телефона родителей': 'Номер телефона родителей',
    'Личные данные': 'Личные данные',
    'Гражданство': 'Гражданство',
    'Документы': 'Документы',
    'Родитель': 'Родитель',
    'Дата': 'Дата',
    'Рассмотрение заявки': 'Рассмотрение заявки',
    'Оценивание': 'Оценивание',
    'Отказать': 'Отказать',
    'Принять': 'Принять',
    'Документ не найден': 'Документ не найден',
    'Отказать в приёме заявки?': 'Отказать в приёме заявки?',
    'Назначить экзамен': 'Назначить экзамен',
    'Поставить оценку экзамена': 'Поставить оценку экзамена',
    'Поставить оценку СКБ': 'Поставить оценку СКБ',
    'Приемная комиссия': 'Приемная комиссия',
    'Казахстан': 'Казахстан',
    'Репатриант': 'Репатриант',
    'Оралман': 'Оралман',
    'Резидент РК': 'Резидент РК',
    'Гражданин РК': 'Гражданин РК',
    'Наименование': 'Наименование',
    'Форма собственности': 'Форма собственности',
    'Адрес': 'Адрес',
    'Телефон': 'Телефон',
    'Пункт образования': 'Пункт образования',
    'Тип организации': 'Тип организации',
    'БИН': 'БИН',
    'Частная': 'Частная',
    'Государственная': 'Государственная',
    'Республиканский': 'Республиканский',
    'Государственное учреждение': 'Государственное учреждение',
    'Частное учреждение': 'Частное учреждение',
    'Оценки СКБ': 'Оценки СКБ',
    'Ожидающие итогов конкурса': 'Ожидающие итогов конкурса',
    'Не прошедшие конкурс': 'Не прошедшие конкурс',
    'Прошедшие конкурс': 'Прошедшие конкурс',
    'СКБ формула не настроена!': 'СКБ формула не настроена!',
}